var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2H1.50001C0.672715 2 0 2.67271 0 3.50001V14C0 14.8273 0.672715 15.5 1.50001 15.5H16.5C17.3273 15.5 18 14.8273 18 14V3.50001C18 2.67271 17.3273 2 16.5 2ZM1.50001 2.74999H16.5C16.5411 2.74999 16.5766 2.76707 16.6158 2.77344L9.39843 8.63318C9.15451 8.78734 8.8059 8.76245 8.62829 8.65297L1.38393 2.77354C1.42327 2.76711 1.45884 2.74999 1.50001 2.74999ZM17.25 14C17.25 14.4134 16.9135 14.75 16.5 14.75H1.50001C1.08657 14.75 0.750023 14.4134 0.750023 14V3.50001C0.750023 3.41616 0.772418 3.33882 0.797906 3.26348L8.18849 9.25903C8.43202 9.41649 8.71291 9.49999 9 9.49999C9.27686 9.49999 9.54714 9.42272 9.78444 9.27587C9.80641 9.26451 9.8273 9.25098 9.84632 9.23523L17.2021 3.2633C17.2276 3.33871 17.25 3.41609 17.25 3.50001V14H17.25Z",
    fill: "#07AFF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.ec4e96ae46f094456080bbd1b698623a.svg";
export { ForwardRef as ReactComponent };